import { EstablishmentModel } from '../../../models/establishmentModel'

export enum EstablishmentsActionTypes {
    SET_ESTABLISHMENT = '@@sugg1144/establishments/SET_ESTABLISHMENT',
}

export interface EstablishmentsState {
    establishments: Array<EstablishmentModel>
}
